package dev.youndie.site.pages.blog

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.youndie.site.blog.BLOG_ENTRIES
import dev.youndie.site.components.layouts.PageLayoutData
import dev.youndie.site.components.widgets.Prompt
import dev.youndie.site.model.SITE_NAME
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initBlogIndex(ctx: InitRouteContext) {
    ctx.data.add(
        PageLayoutData(
            title = "blog — $SITE_NAME",
            description = "Notes on Kotlin, Kotlin/Native and the libraries I maintain.",
        )
    )
}

@Page
@Composable
fun BlogIndexPage() {
    Section(attrs = { classes("hero") }) {
        Prompt("ls -lt blog/", path = "~")
        H1 { Text("blog") }
        P { Text("Notes on Kotlin, Kotlin/Native, and whatever I'm currently building.") }
    }

    Section(attrs = { classes("section") }) {
        if (BLOG_ENTRIES.isEmpty()) {
            Div(attrs = { classes("empty") }) { Text("Nothing here yet.") }
        } else {
            Div(attrs = { classes("post-list") }) {
                BLOG_ENTRIES.forEach { entry ->
                    Link(entry.route, modifier = Modifier.classNames("post-item")) {
                        Div(attrs = { classes("post-date") }) { Text(entry.date) }
                        Div(attrs = { classes("post-title") }) { Text(entry.title) }
                        if (entry.description.isNotEmpty()) {
                            P(attrs = { classes("post-desc") }) { Text(entry.description) }
                        }
                    }
                }
            }
        }
    }
}
